// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ExternalSubscriptionListController = function ($scope, ExternalSubscription, PUtill) {

    $scope.filters = {};
    $scope.pactasDates = {};
    $scope.productType = PUtill.getText("All");

    $scope.readSubscriptions = function() {
        $scope.prepareDateFilters();
        $scope.subscriptions = $scope.paginator(ExternalSubscription.query, $scope.filters, 20);
    };

    $scope.setExternalSubscriptionType = function(value, text) {
        $scope.productType = PUtill.getText(text || value);
        $scope.filters.Type = value;
        $scope.readSubscriptions();
    };

    $scope.clearSerchStringFilter = function() {
        $scope.filters.searchString = '';
        $scope.readSubscriptions();
    };

    var setFilterDate = function(propertyName) {
        if (!$scope.pactasDates[propertyName]) {
            return;
        }

        var pactasDate = $scope.pactasDates[propertyName];
        var dTo = new Date();
        dTo.setTime(Date.parse(pactasDate));
        dTo.setDate(dTo.getDate() + 1);
        $scope.filters[propertyName] = PUtill.toISOString(dTo);
    };

    $scope.prepareDateFilters = function() {
        setFilterDate('startsFrom');
        setFilterDate('startsTo');
        setFilterDate('endsFrom');
        setFilterDate('endsTo');
    };

    $scope.readSubscriptions();
};
ExternalSubscriptionListController.$inject = ['$scope', 'ExternalSubscription','PUtill'];
